import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaArrowLeftLong } from "react-icons/fa6";

import FormInput from "../../../components/common/FormInput/FormInput";
import UploadImage from "../../../components/common/UploadImage/UplaodImage";
import Button from "../../../components/common/Button/Button";
import Editor from "../../../components/Editor/Editor";

import { getBlogById, updateBlog } from "../../../api/service/blog.service";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";

const UpdateBlog = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [existingImage, setExistingImage] = useState("");
  const [blogImage, setBlogImage] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    text: "",
    author: "",
    category: "",
  });

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);


  useEffect(() => {
    const fetchBlogDetails = async () => {
      try {
        setFetching(true);
        const response = await getBlogById(id);

        if (response?.data) {
          const blog = response.data;

          setFormData({
            title: blog.title || "",
            text: blog.text || "", 
            author: blog.author || "",
            category: blog.category || "",
          });

          setExistingImage(blog.photo?.url || "");
        }
      } catch (error) {
        console.error("Fetch Error:", error);
        showToast.error("Failed to load blog details.");
      } finally {
        setFetching(false);
      }
    };

    if (id) fetchBlogDetails();
  }, [id]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (file) => {
    setBlogImage(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      showToast.error("Please enter blog title");
      return;
    }

    if (!formData.text || formData.text === "<p><br></p>") {
      showToast.error("Please enter blog content");
      return;
    }

    try {
      setLoading(true);

      const submitData = new FormData();
      submitData.append("blog_id", id);
      submitData.append("title", formData.title);
      submitData.append("text", formData.text);
      submitData.append("author", formData.author);
      submitData.append("category", formData.category);

      if (blogImage) {
        submitData.append("photo", blogImage);
      }

      const response = await updateBlog(submitData);

      if (response?.success) {
        showToast.success("Blog updated successfully!");
        setTimeout(() => navigate("/blog"), 1200);
      } else {
        showToast.error(response?.message || "Failed to update blog");
      }
    } catch (error) {
      console.error("Update Error:", error);
      showToast.error(error?.response?.data?.message || "Failed to update blog");
    } finally {
      setLoading(false);
    }
  };


  if (fetching) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "400px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }


  return (
    <>
      <div className="d-flex align-items-center gap-2 mb-3">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <h3 className="mb-0">Update Blog</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <Row>
     
          <Col xs={12} className="mb-3">
            <label className="form-label">Blog Image</label>
            <UploadImage
              onFileSelect={handleFileChange}
              existingImages={existingImage}
              multiple={false}
            />
          </Col>

      
          <Col xs={12} className="mb-3">
            <label className="form-label">Title</label>
            <FormInput
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="Enter blog title"
              required
            />
          </Col>

          <Col xs={12} className="mb-4">
            <label className="form-label">Blog Content</label>
            <Editor
              value={formData.text}
              onChange={(value) =>
                setFormData((prev) => ({
                  ...prev,
                  text: value,
                }))
              }
              height="350px"
              placeholder="Write blog content here..."
            />
          </Col>

  
          <Col xs={12} md={6} className="mb-3">
            <label className="form-label">Category</label>
            <FormInput
              name="category"
              value={formData.category}
              onChange={handleInputChange}
              placeholder="Enter category"
            />
          </Col>

   
          <Col xs={12} md={6} className="mb-3">
            <label className="form-label">Author</label>
            <FormInput
              name="author"
              value={formData.author}
              onChange={handleInputChange}
              placeholder="Enter author name"
            />
          </Col>

   
          <Col xs={12}>
            <Button type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update Blog"}
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default UpdateBlog;
